import LabReportListItem from "./LabReportListItem";
import {
  ReportsContainer,
  ReportsHeader,
  NoReportsText,
  ReportsList,
} from "./LabReports.style";
import { useTranslation } from "react-i18next";
import { ILabReportData } from "@home-health-notify/domain/build/chat/labs/ILabOrderData";

type LabReportsProps = {
  reports: ILabReportData[];
};

const LabReports = ({ reports }: LabReportsProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "labRequisition" });

  if (!reports || reports.length === 0) {
    return (
      <ReportsContainer>
        <ReportsHeader>{tNs("reports")}</ReportsHeader>
        <NoReportsText>{tNs("noReportsAvailable")}</NoReportsText>
      </ReportsContainer>
    );
  }

  return (
    <ReportsContainer>
      <ReportsHeader>{tNs("reports")}</ReportsHeader>
      <ReportsList>
        {reports.map(report => (
          <LabReportListItem key={report.fileUrl} report={report} />
        ))}
      </ReportsList>
    </ReportsContainer>
  );
};

export default LabReports;
